/**
 * @desc Names of the Redux dispatch events.
 * @example
 * import * as REDUX_EVENTS from 'constants/redux-events';
 * console.log( REDUX_EVENTS.USER_LOGGED_IN );
 */

// session management
export const USER_LOGGED_IN = 'REDUX_ACTION:USER_LOGGED_IN';
export const CLEAR_USER_SESSION = 'REDUX_ACTION:CLEAR_USER_SESSION';

// network response processing
export const INITIALISE_URLS = 'REDUX_ACTION:INITIALISE_URLS';
export const UPDATE_APP_CONTEXT = 'REDUX_ACTION:UPDATE_APP_CONTEXT';
export const ADD_URLS = 'REDUX_ACTION:ADD_URLS';
export const ADD_LABELS = 'REDUX_ACTION:ADD_LABELS';
export const ADD_COMPONENT_DATA = 'REDUX_ACTION:ADD_COMPONENT_DATA';

// call state management
export const INIT_CALL_STATE = 'REDUX_ACTION:INIT_CALL_STATE';
export const UPDATE_CALL_STATE = 'REDUX_ACTION:UPDATE_CALL_STATE';
export const ADD_VERIFIED_MEMBER = 'REDUX_ACTION:ADD_VERIFIED_MEMBER';
export const CLEAR_CALL_STATE = 'REDUX_ACTION:CLEAR_CALL_STATE';

// checkout action
export const UPDATE_CHECKOUT_STATE = 'REDUX_ACTION:UPDATE_CHECKOUT_STATE';
export const CLEAR_CHECKOUT_STATE = 'REDUX_ACTION:CLEAR_CHECKOUT_STATE';

// member verification state
export const UPDATE_MEMBER_VERIFICATION_STATE = 'REDUX_ACTION:UPDATE_MEMBER_VERIFICATION_STATE';
export const CLEAR_MEMBER_VERIFICATION_STATE = 'REDUX_ACTION:CLEAR_MEMBER_VERIFICATION_STATE';

// member management state
export const UPDATE_MEMBER_MANAGEMENT_STATE = 'REDUX_ACTION:UPDATE_MEMBER_MANAGEMENT_STATE';
export const CLEAR_MEMBER_MANAGEMENT_STATE = 'REDUX_ACTION:CLEAR_MEMBER_MANAGEMENT_STATE';
